(ns app.front.view.admin.superdomain
  (:require [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.admin.common :as acommon]
            [app.front.view.group.admin.common :as gacommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::create-data
  :<- [::state]
  :-> :create-data)

(rf/reg-event-db ::reset-create-data
  (rf/path [::state :create-data])
  (constantly {}))

(rf/reg-event-db ::create-set-field
  (rf/path [::state :create-data])
  (fn [data [_ k v]]
    (assoc data k v)))

(rf/reg-sub ::valid-create-data?
  :<- [::create-data]
  (fn [data]
    (futil/not-blank? (:group/name data))))

(rf/reg-event-fx ::create-superdomain
  (fn [_ [_ data]]
    {:comm/command (util/mmap {:command    :admin/create-superdomain-group
                               :on-success [::create-superdomain.success]
                               :notify     {:success :admin.superdomain/created-success}}
                              data)}))

(rf/reg-event-fx ::create-superdomain.success
  (fn [_ [_ status entities]]
    {:fx [[:dispatch [::entities/apply-changes status entities]]
          [:dispatch [::reset-create-data]]]}))

(rf/reg-event-fx ::fetch-superdomains
  (fn [{:keys [db]} _]
    {:db           (assoc-in db [::state :loading-superdomains?] true)
     :comm/command {:command    :admin/superdomain-groups
                    :method     :get
                    :on-success [::fetch-superdomains.success]}}))

(rf/reg-event-fx ::fetch-superdomains.success
  (fn [{:keys [db]} [_ status resp]]
    (let [entities  (:entities resp)
          timezones (:timezones resp)]
      {:db       (-> db
                     (assoc ::timezones timezones)
                     (assoc-in [::state :loading-superdomains?] false))
       :dispatch [::entities/merge-entity-db status entities]})))

(rf/reg-event-fx ::fetch-available-domain-groups
  (fn [{:keys [db]} _]
    {:db           (assoc-in db [::state :loading-available-domain-groups?] true)
     :comm/command {:command    :admin/available-domain-groups-for-superdomains
                    :method     :get
                    :on-success [::fetch-available-domain-groups.success]}}))

(rf/reg-event-fx ::fetch-available-domain-groups.success
  (fn [{:keys [db]} [_ status entities]]
    {:db       (-> db
                   (assoc-in [::state :loading-available-domain-groups?] false)
                   (assoc-in [::state :available-domain-groups-for-superdomains]
                             (some->> entities
                                      vals
                                      (filter group-model/domain?)
                                      vec)))
     :dispatch [::entities/merge-entity-db status entities]}))

(rf/reg-sub ::superdomains
  :<- [::entities/entities {:group/type :group.type/superdomain}]
  :-> (partial sort-by :group/name))

(rf/reg-sub ::loading-superdomains?
  :<- [::state]
  :-> :loading-superdomains?)

(rf/reg-sub ::loading-available-domain-groups?
  :<- [::state]
  :-> :loading-available-domain-groups?)

(rf/reg-sub ::loading?
  :<- [::loading-superdomains?]
  :<- [::loading-available-domain-groups?]
  :-> (partial some true?))

(rf/reg-sub ::expanded-superdomain-rows
  :<- [::state]
  :-> :expanded-superdomain-rows)

(rf/reg-sub ::expanded-domain-group-rows
  :<- [::state]
  :-> :expanded-domain-group-rows)

(rf/reg-sub ::expanded-domain-group-rows-for-superdomain
  :<- [::expanded-domain-group-rows]
  (fn [expanded-rows [_ superdomain-id]]
    (get expanded-rows superdomain-id #{})))

(rf/reg-sub ::available-domain-groups-for-superdomains
  :<- [::state]
  :-> (comp (partial sort-by :group/name)
            :available-domain-groups-for-superdomains))

(rf/reg-sub ::available-domain-groups-for-superdomain
  :<- [::available-domain-groups-for-superdomains]
  (fn [available-domain-groups [_ superdomain]]
    (let [superdomain-domain-group-ids (->> superdomain
                                            group-model/superdomain-domain-groups
                                            (map :db/id)
                                            set)]
      (->> available-domain-groups
           (remove #(contains? superdomain-domain-group-ids (:db/id %)))))))

(rf/reg-sub ::any-available-domain-groups-for-superdomain?
  (fn [[_ superdomain]]
    (rf/subscribe [::available-domain-groups-for-superdomain superdomain]))
  (fn [available-domain-groups _]
    (-> available-domain-groups seq boolean)))

(rf/reg-event-db ::toggle-superdomain-row-expansion
  (rf/path [::state :expanded-superdomain-rows])
  (fn [expanded-rows [_ row-key]]
    (util/toggle-in-set expanded-rows row-key)))

(rf/reg-event-db ::toggle-domain-group-row-expansion
  (rf/path [::state :expanded-domain-group-rows])
  (fn [expanded-rows [_ superdomain-id row-key]]
    (update expanded-rows superdomain-id #(util/toggle-in-set % row-key))))

(rf/reg-event-db ::update-domain-group-to-add-for-superdomain
  (rf/path [::state :all-domain-groups-to-add-for-superdomain])
  (fn [domain-group-to-add [_ superdomain-id domain-group]]
    (assoc domain-group-to-add superdomain-id domain-group)))

(rf/reg-sub ::all-domain-groups-to-add-for-superdomain
  :<- [::state]
  :-> :all-domain-groups-to-add-for-superdomain)

(rf/reg-sub ::domain-group-to-add-for-superdomain
  :<- [::all-domain-groups-to-add-for-superdomain]
  (fn [domain-group-to-add [_ superdomain-id]]
    (get domain-group-to-add superdomain-id)))

(rf/reg-sub ::group-to-be-added-has-workspaces?
  (fn [[_ superdomain-id]]
    (rf/subscribe [::domain-group-to-add-for-superdomain superdomain-id]))
  :-> :has-workspaces?)

(rf/reg-sub ::group-to-be-added-has-complaints?
  (fn [[_ superdomain-id]]
    (rf/subscribe [::domain-group-to-add-for-superdomain superdomain-id]))
  :-> :has-complaints?)

(rf/reg-event-fx ::add-domain-group-to-superdomain
  (fn [_ [_ superdomain-id domain-group-id]]
    {:comm/command {:command    :admin/add-domain-group-to-superdomain
                    :on-success [::add-domain-group-to-superdomain.success superdomain-id]
                    :data       (util/mmap superdomain-id
                                           domain-group-id)
                    :notify     {:success :admin.superdomain/add-domain-group-success}}}))

(rf/reg-event-fx ::add-domain-group-to-superdomain.success
  (fn [_ [_ superdomain-id status entities]]
    {:fx [[:dispatch [::entities/apply-changes status entities]]
          [:dispatch [::fetch-superdomains]]
          [:dispatch [::fetch-available-domain-groups]]
          [:dispatch [::update-domain-group-to-add-for-superdomain superdomain-id nil]]]}))

(defn- latest-async-jobs-for-superdomain
  "Returns the latest async job per domain-group for a superdomain, filtered by task type."
  [ctx superdomain-id task-type]
  (->> (entities/find-entities ctx {:entity/type    :entity.type/async-job
                                    :async-job/task task-type})
       (filter #(-> % :async-job/group :db/id (= superdomain-id)))
       (sort-by :entity/created >)
       (reduce (fn [acc job]
                 (let [dg-id (-> job :async-job/data :domain-group-id)]
                   (if (contains? (:seen acc) dg-id)
                     acc
                     (-> acc
                         (update :seen conj dg-id)
                         (update :jobs conj job)))))
               {:seen #{} :jobs []})
       :jobs))

(rf/reg-sub ::workspace-async-jobs-for-superdomain
  :<- [::entities/context]
  (fn [ctx [_ superdomain-id]]
    (latest-async-jobs-for-superdomain ctx
                                       superdomain-id
                                       :async-job.task/superdomain-workspace-authorization-migration)))

(rf/reg-sub ::complaint-async-jobs-for-superdomain
  :<- [::entities/context]
  (fn [ctx [_ superdomain-id]]
    (latest-async-jobs-for-superdomain ctx
                                       superdomain-id
                                       :async-job.task/superdomain-complaint-authorization-migration)))

(rf/reg-sub ::any-migration-running?
  (fn [[_ superdomain-id]]
    [(rf/subscribe [::workspace-async-jobs-for-superdomain superdomain-id])
     (rf/subscribe [::complaint-async-jobs-for-superdomain superdomain-id])])
  (fn [[ws-jobs cmp-jobs] _]
    (boolean (some (du/in-state-fn :async-job.state/running)
                   (concat ws-jobs cmp-jobs)))))

(defn- retry-migration-handler [command]
  (fn [_ [_ async-job-id superdomain-id]]
    {:comm/command {:command    command
                    :data       {:async-job-id async-job-id}
                    :on-success [::retry-migration.success superdomain-id]
                    :notify     {:success :admin.superdomain/retry-migration-success}}}))

(rf/reg-event-fx ::retry-workspace-authz-migration
  (retry-migration-handler :admin/retry-superdomain-workspace-authz-migration))

(rf/reg-event-fx ::retry-complaint-authz-migration
  (retry-migration-handler :admin/retry-superdomain-complaint-authz-migration))

(rf/reg-event-fx ::retry-migration.success
  (fn [_ [_ _superdomain-id status entities]]
    {:dispatch [::entities/apply-changes status entities]}))

(rf/reg-sub ::timezones
  :-> ::timezones)

(rf/reg-sub ::chosen-timezone
  (fn [db [_ superdomain-id]]
    (get-in db [::chosen-timezone superdomain-id])))

(rf/reg-event-fx ::set-timezone
  (fn [_ [_ tz id]]
    {:comm/command {:command    :admin/set-superdomain-data
                    :data       {:superdomain-id id
                                 :timezone       tz}
                    :on-success [::set-timezone.success tz id]}}))

(rf/reg-event-db ::set-timezone.success
  (fn [db [_ tz id]]
    (assoc-in db [::chosen-timezone id] tz)))

(defn- create-superdomain [tr]
  (let [create-data           (<sub [::create-data])
        tr-create-superdomain (tr [:admin.superdomain/create-superdomain])]
    [section/section
     :create-superdomain
     (util/mmap tr)
     tr-create-superdomain
     [:div.flex.flex-col.gap-4
      [:p (tr [:admin.superdomain/create-superdomain-description])]
      [ui/text-input {:id          "group-name"
                      :label-text  (tr [:admin.superdomain/name])
                      :value       (:group/name create-data)
                      :on-change   #(>evt [::create-set-field :group/name (futil/tval %)])
                      :placeholder (tr [:admin.superdomain/name-placeholder])}]
      [:div.flex.justify-end
       [ui/button {:kind     :primary
                   :disabled (not (<sub [::valid-create-data?]))
                   :on-click #(>evt [::create-superdomain create-data])}
        tr-create-superdomain]]]]))

(defn- async-job-status-display [tr
                                 async-job
                                 superdomain-id
                                 {:keys [progress-key
                                         partial-success-key
                                         failed-ids-key
                                         retry-event]}]
  (let [state         (:domain/state async-job)
        total         (:async-job/total-count async-job)
        processed     (:async-job/processed-count async-job)
        error         (:async-job/error async-job)
        data          (-> async-job :async-job/data)
        failed-count  (count (get data failed-ids-key))
        success-count (max 0 (- processed failed-count))
        last-error    (:last-error data)
        any-running?  (<sub [::any-migration-running? superdomain-id])
        state-class   (case state
                        :async-job.state/running "text-blue-600"
                        :async-job.state/ready   "text-green-600"
                        :async-job.state/failed  "text-red-600"
                        "text-gray-600")
        state-text    (case state
                        :async-job.state/running (tr [:admin.superdomain/migration-running])
                        :async-job.state/ready   (tr [:admin.superdomain/migration-completed])
                        :async-job.state/failed  (tr [:admin.superdomain/migration-failed])
                        (str state))]
    [:div.border.border-gray-300.rounded.p-4.my-2
     [:div.flex.justify-between.items-center
      [:div.flex-1
       [:div.flex.items-center.gap-2
        [:span.font-semibold {:class state-class} state-text]
        (when (= state :async-job.state/running)
          (cc/loading-spinner {:with-overlay false :small true}))]
       [:div.text-sm.text-gray-600.mt-1
        (tr [progress-key] [processed total])]
       (when (and (= state :async-job.state/failed) (pos? failed-count))
         [:div.text-sm.text-yellow-600.mt-1
          (tr [partial-success-key] [success-count total failed-count])])
       (when (or error last-error)
         [:div.text-sm.text-red-600.mt-2
          [:strong (tr [:admin.superdomain/error]) ": "]
          (or error last-error)])]
      (when (and (= state :async-job.state/failed)
                 (not any-running?))
        [:div
         [ui/button {:kind     :secondary
                     :size     :small
                     :on-click #(>evt [retry-event (:async-job/id async-job) superdomain-id])}
          (tr [:admin.superdomain/retry-migration])]])]]))

(defn- expand-superdomain
  "shared services group expansion shows domain groups that belong to the shared services group.
  Also shows a button to add existing domain groups."
  [tr superdomain]
  (let [superdomain-id           (:db/id superdomain)
        domain-group-to-be-added (<sub [::domain-group-to-add-for-superdomain superdomain-id])
        domain-groups            (group-model/superdomain-domain-groups superdomain)
        timezones                (<sub [::timezones])
        ws-async-jobs            (<sub [::workspace-async-jobs-for-superdomain superdomain-id])
        cmp-async-jobs           (<sub [::complaint-async-jobs-for-superdomain superdomain-id])
        has-workspaces?          (<sub [::group-to-be-added-has-workspaces? superdomain-id])
        has-complaints?          (<sub [::group-to-be-added-has-complaints? superdomain-id])
        has-data?                (or has-workspaces? has-complaints?)]
    [:div.px-6.flex.flex-col.gap-4
     [:<>
      [:h4 (tr [:admin.superdomain/superdomain-settings])]
      [:div.flex.flex-row
       (cc/select
         {:id         "timezone"
          :label-text (tr [:admin/timezone])
          :value      (or (<sub [::chosen-timezone superdomain-id])
                          (:group/tz superdomain)
                          :none)
          :on-change  #(>evt [::set-timezone (futil/tval %) superdomain-id])}
         [ui/placeholder-select-item tr]
         (for-frag [tz timezones]
           (cc/select-item {:text  tz
                            :value tz})))]
      ;; Workspace async jobs section
      (when (seq ws-async-jobs)
        [:<>
         [:h4 (tr [:admin.superdomain/workspace-migrations])]
         [:div
          (for-frag [job ws-async-jobs]
            [async-job-status-display tr job superdomain-id
             {:progress-key        :admin.superdomain/migration-progress
              :partial-success-key :admin.superdomain/migration-partial-success
              :failed-ids-key      :failed-workspace-ids
              :retry-event         ::retry-workspace-authz-migration}])]])
      ;; Complaint async jobs section
      (when (seq cmp-async-jobs)
        [:<>
         [:h4 (tr [:admin.superdomain/complaint-migrations])]
         [:div
          (for-frag [job cmp-async-jobs]
            [async-job-status-display tr job superdomain-id
             {:progress-key        :admin.superdomain/complaint-migration-progress
              :partial-success-key :admin.superdomain/complaint-migration-partial-success
              :failed-ids-key      :failed-complaint-ids
              :retry-event         ::retry-complaint-authz-migration}])]])
      [:h4 (tr [:admin.superdomain/domain-groups])]
      (if (seq domain-groups)
        [ui-table/modern-responsive-table
         {:tr                tr
          :items             domain-groups
          :id-func           :db/id
          :cols              [[:admin.superdomain/domain-group-name :group/name]
                              [:admin.superdomain/group-id :group/id]]
          :expanded-row-keys (<sub [::expanded-domain-group-rows-for-superdomain superdomain-id])
          :on-expand         #(>evt [::toggle-domain-group-row-expansion superdomain-id %])}]
        [:p (tr [:admin.superdomain/no-domain-groups])])]
     (when (<sub [::any-available-domain-groups-for-superdomain? superdomain])
       [:div.flex.flex-col.gap-4
        [:div.flex
         [acommon/group-selector {:title-text          (tr [:admin.superdomain/select-group-to-add])
                                  :tr                  tr
                                  :on-change           #(>evt [::update-domain-group-to-add-for-superdomain superdomain-id %])
                                  :groups-subscription [::available-domain-groups-for-superdomain superdomain]}]]
        (when has-data?
          [ui/warning (cond
                        (and has-workspaces? has-complaints?) (tr [:admin.superdomain/domain-has-data-warning])
                        has-workspaces?                       (tr [:admin.superdomain/domain-has-workspaces-warning])
                        :else                                 (tr [:admin.superdomain/domain-has-complaints-warning]))])
        [:div.flex.mb-4
         [ui/modal-confirmation-button
          {:id                  (str "add-domain-group-to-superdomain-" superdomain-id)
           :tr                  tr
           :modal-title         (if has-data?
                                  (tr [:admin.superdomain/add-domain-with-data-title])
                                  (tr [:admin.superdomain/add-domain-to-shared-service-group]))
           :disabled?           (nil? domain-group-to-be-added)
           :on-yes-click        #(>evt [::add-domain-group-to-superdomain superdomain-id (:id domain-group-to-be-added)])
           :trigger-button-text (tr [:admin.superdomain/add-domain-to-shared-service-group])}
          (if has-data?
            (tr [:admin.superdomain/confirm-add-domain-group-with-data]
                [(:label domain-group-to-be-added)])
            (tr [:admin.superdomain/confirm-add-domain-group]
                [(:label domain-group-to-be-added)
                 (:group/name superdomain)
                 (:group/id superdomain)]))]]])]))

(defn- superdomain-list [tr]
  (let [superdomains    (<sub [::superdomains])
        tr-superdomains (tr [:admin.superdomain/superdomains])]
    [section/section
     :superdomains
     (util/mmap {:initially-collapsed? (-> superdomains seq boolean not)}
                tr)
     tr-superdomains
     [:<>
      [:div
       (if (<sub [::loading?])
         (cc/loading-spinner {:with-overlay false})
         [ui-table/modern-responsive-table
          {:tr                tr
           :items             superdomains
           :id-func           :db/id
           :cols              [[:admin.superdomain/superdomain-name :group/name]
                               [:admin.superdomain/group-id :group/id]]
           :expanded-func     (partial expand-superdomain tr)
           :expanded-row-keys (<sub [::expanded-superdomain-rows])
           :on-expand         #(>evt [::toggle-superdomain-row-expansion %])}])]]]))

(defn view [_match]
  (let [tr (<sub [:tr])]
    [gacommon/admin-page
     {:title (tr [:admin.superdomain/title])}
     [create-superdomain tr]
     [superdomain-list tr]]))

(def route
  {:name        :view/admin.superdomain
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-superdomains])
                           (>evt [::fetch-available-domain-groups])
                           (>evt [::reset-create-data]))}]})
